import React from "react";

import { Box } from "@mui/material";

import { BackgroundFit } from "../../types";

interface BackgroundLayerProps {
  image: string;
  overlay: number;
  overlayColor: string;
  fit: BackgroundFit;
}

export default function BackgroundLayer({
  image,
  overlay,
  overlayColor,
  fit,
}: BackgroundLayerProps) {
  return (
    <>
      {/* Blurred fill layer (for "blur" fit mode) */}
      {fit === "blur" && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(20px)",
            transform: "scale(1.1)",
            zIndex: 0,
          }}
        />
      )}

      {/* Main image layer */}
      <Box
        component="img"
        src={image}
        alt=""
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: fit === "blur" ? "contain" : fit,
          objectPosition: "center",
          zIndex: fit === "blur" ? 1 : 0,
        }}
      />

      {/* Dark overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: overlayColor,
          opacity: overlay,
          zIndex: 2,
        }}
      />
    </>
  );
}
